import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import * as Sentry from '@sentry/react';

const ADMIN_ROLES = ['admin', 'Cardiology Coordinator'];

const isAdminRole = (role) => typeof role === 'string' && ADMIN_ROLES.includes(role.trim());

const AdminGuard = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        Sentry.addBreadcrumb({
          message: 'AdminGuard: Checking admin privileges',
          level: 'info'
        });
        
        const response = await axios.get('/api/staffMembers/info');
        const userRole = response.data?.role;
        
        Sentry.addBreadcrumb({
          message: `AdminGuard: User role is ${userRole}`,
          level: 'info'
        });
        
        if (isAdminRole(userRole)) {
          setIsAdmin(true);
        } else {
          Sentry.addBreadcrumb({
            message: 'AdminGuard: Access denied - not an admin',
            level: 'warning'
          });
          setIsAdmin(false);
          navigate('/Panel', { replace: true });
        }
      } catch (error) {
        const status = error.response?.status;
        Sentry.addBreadcrumb({
          message: `AdminGuard: Authentication check failed: ${status}`,
          level: 'warning'
        });
        
        setIsAdmin(false);
        if (status === 401 || status === 403) {
          navigate('/Login', { replace: true });
        } else {
          navigate('/Panel', { replace: true });
        }
      } finally {
        setIsLoading(false);
      }
    };

    checkAdmin();
  }, [navigate]);

  if (isLoading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  if (!isAdmin) {
    return null;
  }

  return children;
};

export default AdminGuard;
